import React from 'react';
import Views from '.';
import FullBody from './full-body';

const FullBodyContentView = ({title, fullCaption}) => {
  return (
    <Views title={title}>
      <FullBody fullCaption={fullCaption} />
    </Views>
  );
};

export default FullBodyContentView;
